module.exports = "/images/easyLogoBigBackground.jpg";